import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://playsocrates.com';
const DEFAULT_TITLE = 'Socrates — Choose your league. Pick one team each round.';
const DEFAULT_DESCRIPTION =
  'Socrates is a private pick-one-team football competition for you and your friends. Pick a Premier League side each match week, earn points for wins, goal difference and clean discipline, and use your Double Down to swing the season.';

interface PageMetaProps {
  title?: string;
  description?: string;
  path?: string;
  noIndex?: boolean;
}

export function PageMeta({ title, description, path, noIndex }: PageMetaProps) {
  const pageTitle = title ? `${title} | Socrates` : DEFAULT_TITLE;
  const pageDescription = description || DEFAULT_DESCRIPTION;
  const canonical = path ? `${SITE_URL}${path}` : SITE_URL;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <link rel="canonical" href={canonical} />

      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:url" content={canonical} />

      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />

      {noIndex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
}
